import {RosterResource} from "../resource/RosterResource";
import {Roster} from "../league/Roster";
import {IApiRoster, IApiRosterHistoryEvent} from "../typings/apiResponse";
import {RosterHistoryEvent} from "../league/RosterHistoryEvent";

export class RosterService {

    public static $inject = ["RosterResource"];
    constructor(private RosterResource: RosterResource) {
    }

    public getRoster(leagueId: number, teamId: number): angular.IPromise<Roster> {
        return this.RosterResource.getRoster(leagueId, teamId)
            .then((roster: IApiRoster) => new Roster(roster));
    }

    public getRosterHistory(leagueId: number, teamId: number): angular.IPromise<RosterHistoryEvent[]> {
        return this.RosterResource.getRosterHistory(leagueId, teamId)
            .then((rosterHistory: IApiRosterHistoryEvent[]) => {
                return rosterHistory.map(rosterHistoryEvent => new RosterHistoryEvent(rosterHistoryEvent));
            });
    }

    /**
     * @param leagueId
     * @param teamId
     * @param playerId
     * @returns {Promise<angular.IHttpPromise<any>>}
     */
    public addPlayer(leagueId: number, teamId: number, playerId: number): angular.IHttpPromise<any> {
        return this.RosterResource.addPlayer(leagueId, teamId, playerId);
    }

    /**
     * @param leagueId
     * @param teamId
     * @param playerId
     * @returns {Promise<angular.IHttpPromise<any>>}
     */
    public removePlayer(leagueId: number, teamId: number, playerId: number): angular.IHttpPromise<any> {
        return this.RosterResource.removePlayer(leagueId, teamId, playerId);
    }
}
